import defaultState from './state';

const setCompany = (state, company) => {
  state.company = company;
};

const setIsActive = (state, isActive) => {
  state.isActive = !!isActive;
};

const setSettings = (state, settings) => {
  state.settings = settings || defaultState.settings;
};

const setSettingsLoading = (state, isLoading) => {
  state.settingsLoading = isLoading || defaultState.settingsLoading;
};

const setSettingsError = (state, error) => {
  state.settingsError = error || defaultState.settingsError;
};

export default {
  setCompany,
  setIsActive,
  setSettings,
  setSettingsError,
  setSettingsLoading,
};
